<!--
 * @Description: 医院卡片组件
 * @FilePath: packages/vue-m-comprehensive/src/views/HospitalList/components/HospitalCard.vue
-->
<template>
  <div class="hospital-card" @click="onCard">
    <div class="sort-number">
      <span v-if="hospitalInfo.index <= 2">
        <img :src="rankIcon[hospitalInfo.index]" alt="前三名" />
      </span>
      <span v-else>{{ hospitalInfo.index + 1 }}</span>
    </div>
    <div class="card-right">
      <div class="hospital-name">{{ hospitalInfo.name }}</div>
      <div class="hosptial-label">
        <div class="label-oneline">
          <span v-if="hospitalLabel['is_3a_hospital']" class="hospital-grade">{{
            hospitalLabel['is_3a_hospital']
          }}</span>
          <span v-if="hospitalLabel['rank_detail']" class="clinic-rank">
            {{ hospitalLabel['rank_detail'] }}</span
          >
          <span v-if="hospitalLabel['doctor_count']" class="doctor-number">{{
            hospitalLabel['doctor_count']
          }}</span>
        </div>
        <div class="label-twoline">
          <span v-if="hospitalLabel['is_public_hospital']">{{
            hospitalLabel['is_public_hospital']
          }}</span>
          <span
            v-if="
              hospitalLabel['is_public_hospital'] &&
                hospitalLabel['is_general_hospital']
            "
            class="sep"
            >|</span
          >
          <span v-if="hospitalLabel['is_general_hospital']">{{
            hospitalLabel['is_general_hospital']
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 前三名展示奖牌图标
const rankIcon = [
  'https://staff.chunyu.mobi/@/media/images/2021/12/21/16e2/dbecb9b38507_w96_h102_.png',
  'https://staff.chunyu.mobi/@/media/images/2021/12/21/dc54/bc08bffdd3aa_w96_h102_.png',
  'https://staff.chunyu.mobi/@/media/images/2021/12/21/d504/c1af1047f3d7_w96_h102_.png',
];
export default {
  name: 'HospitalCard',
  props: {
    // 医院的基本信息
    hospitalInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: () => {
    return {
      rankIcon, // 前三甲需要展示图标
      hospitalLabel: {}, // 医院的相关标签
    };
  },
  watch: {
    // 监听新的医院信息
    hospitalInfo() {
      this.hospitalLabel = this.hospitalInfo.hospital_label || {};
    },
  },
  created() {
    this.hospitalLabel = this.hospitalInfo.hospital_label || {};
  },
  methods: {
    /**
     * 医院卡片点击事件
     */
    onCard() {
      this.$emit('click', this.hospitalInfo);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.hospital-card {
  display: flex;
  align-items: center;
  min-height: rem(102);
  margin: 0 rem(10) rem(10) rem(10);
  padding: rem(15) rem(20);
  background: #fff;
  border-radius: rem(2);
  .sort-number {
    display: flex;
    align-items: center;
    justify-content: center;
    width: rem(42);
    height: rem(18);
    margin-right: rem(19);
    color: #939292;
    font-weight: 600;
    font-size: rem(20);
    line-height: rem(18);
    letter-spacing: 0;
    text-align: center;
    img {
      width: rem(32);
      // height: rem(32);
    }
    span {
      display: inline-block;
      width: rem(40);
    }
  }
  .card-right {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    // justify-content: space-between;
    height: 100%;
    .hospital-name {
      margin-bottom: rem(10);
      color: #323232;
      font-weight: 500;
      font-size: rem(16);
      line-height: rem(18);
      letter-spacing: 0;
      text-align: left;
    }
  }
  .hosptial-label {
    text-align: left;
    .label-oneline {
      span {
        display: inline-block;
        height: rem(22);
        margin-bottom: rem(6);
        font-weight: 400;
        font-size: rem(12);
        text-align: center;
      }
      .hospital-grade {
        width: rem(40);
        height: rem(22);
        margin-right: rem(5);
        color: #fff;
        line-height: rem(22);
        background: #1cc381;
        border-radius: rem(2);
      }
      .clinic-rank {
        margin-right: rem(5);
        padding: rem(4) rem(8);
        color: #91632f;
        background: #f7e9d2;
        border-radius: rem(2);
        img {
          width: rem(10);
          // height: rem(10);
          transform: translateY(rem(2));
        }
      }
      .doctor-number {
        padding: 0 rem(8);
        color: #308ce8;
        line-height: rem(22);
        background: rgba(48, 140, 232, 0.06);
        border-radius: rem(2);
      }
    }
    .label-twoline {
      span {
        margin-right: rem(4.5);
        color: #666;
        font-weight: 400;
        font-size: rem(14);
        // font-family: PingFangSC-Regular, serif;
        line-height: rem(16);
        letter-spacing: 0;
      }
      span.sep {
        color: #f4f4f4;
      }
    }
  }
}
</style>
